import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const useIsFromMobileApp = () => {
  const location = useLocation();

  return useMemo(() => {
    let isMobile = false;

    // before #
    const beforeHashParams = new URLSearchParams(window.location.search);
    if (beforeHashParams.get('from') === 'mobile') {
      isMobile = true;
    }

    // after #
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.get('from') === 'mobile') {
      isMobile = true;
    }

    // check if it contains query params from=mobile
    if (location.hash.includes('?')) {
      const hashQuery = location.hash.substring(location.hash.indexOf('?') + 1);
      const hashParams = new URLSearchParams(hashQuery);
      if (hashParams.get('from') === 'mobile') {
        isMobile = true;
      }
    }

    // save in sessionStorage if we are from mobile
    if (isMobile) {
      sessionStorage.setItem('isFromMobileApp', 'true');
      return true;
    }

    // if we are not from mobile, check if we have this info in sessionStorage, in case we lost the query params
    return sessionStorage.getItem('isFromMobileApp') === 'true';
  }, [location.search, location.hash]);
};
export default useIsFromMobileApp;
